import React from "react";

const BLOCKS = [
  { id: "dates", variant: "line", title: true },
  { id: "labelCount", variant: "bar", title: true },
  { id: "verifyDates", variant: "line", title: true },
  { id: "verifyCount", variant: "pie", title: true },
];

export function AnalyticsChartSkeleton() {
  return (
    <div
      className="analytics-chart-skeleton-grid"
      aria-busy="true"
      aria-label="Загрузка графиков аналитики"
    >
      {BLOCKS.map((block) => (
        <div key={block.id} className="analytics-chart-skeleton graph_item_container">
          <div className="analytics-skeleton-title analytics-skeleton-bar" />
          {block.variant === "bar" ? (
            <div className="chart_skeleton_bars">
              {[65, 45, 80, 55, 70, 40].map((h, i) => (
                <div
                  key={i}
                  className="analytics-skeleton-bar analytics-skeleton-bar--vertical"
                  style={{ height: `${h}%` }}
                />
              ))}
            </div>
          ) : block.variant === "pie" ? (
            <div className="analytics-skeleton-pie analytics-skeleton-bar" />
          ) : (
            <div className="chart_skeleton_chart">
              {[100, 85, 70, 90, 60, 75].map((w, i) => (
                <div
                  key={i}
                  className="analytics-skeleton-bar analytics-skeleton-bar--horizontal"
                  style={{ width: `${w}%` }}
                />
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
